import { Box } from '@chaine/keychaine';
import React from 'react';
let uniqueIdCounter = 0;
export const LogoCarousel = (props) => {
    const { logos, scrollDirection = 'right-to-left' } = props;
    const [uniqueId] = React.useState(() => `logo-carousel-${uniqueIdCounter++}`);
    const logoWidth = 150;
    const spacing = 100;
    const totalLogos = logos.length;
    const totalWidth = totalLogos * (logoWidth + spacing);
    const isRtl = scrollDirection === 'right-to-left';
    const keyframesName = `scroll-${uniqueId}`;
    return (React.createElement(Box, { overflowX: "hidden", w: "100%" },
        React.createElement(Box, { display: "flex", sx: {
                animation: `${(totalWidth / 100) * 2}s linear infinite ${keyframesName}`,
                [`@keyframes ${keyframesName}`]: {
                    from: { transform: `translateX(${isRtl ? 0 : -totalWidth}px)` },
                    to: { transform: `translateX(${isRtl ? -totalWidth : 0}px)` }
                },
                width: `${totalWidth * 2}px`
            } }, logos.concat(logos).map((LogoComponent, index) => (React.createElement(Box, { key: index, display: "flex", justifyContent: "center", width: `${logoWidth}px`, mx: `${spacing / 2}px` }, LogoComponent)))),
        React.createElement(Box, { top: "0", left: "0", bottom: "0", w: "40px", bgGradient: "linear(to-r, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))", zIndex: "1" }),
        React.createElement(Box, { top: "0", right: "0", bottom: "0", w: "40px", bgGradient: "linear(to-l, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))", zIndex: "1" })));
};
